// removed by extract-text-webpack-plugin
module.exports = {"container":"container___19UTW","loading":"loading___akm5m","pageTools":"pageTools___3AFqu","button":"button___1tj3h","message":"message___1syae","itemList":"itemList___2CCuQ","listing":"listing___1USk3"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Items/styles.scss
// module id = 331
// module chunks = 0